import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";

import { App } from "./App";
import { initTheme } from "./ui/theme";
// KaTeX draws formulae with absolutely positioned glyphs, so its stylesheet
// is not decoration — without it the mathematics is unreadable. Imported so
// the build emits it and its fonts alongside everything else: nothing here
// is fetched from a font CDN.
import "katex/dist/katex.min.css";
import "./index.css";

// Before the first render, so the page never flashes the wrong colours.
initTheme();

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (dsn) {
  Sentry.init({ dsn, environment: import.meta.env.MODE, tracesSampleRate: 0 });
}

registerSW({ immediate: true });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
